import React from 'react';
import { Table } from 'react-bootstrap';
import { ReceptionDesktopListItem } from './ReceptionDesktopListItem';
import { IReceptionListProps } from './types';

export const ReceptionDesktopList: React.FC<IReceptionListProps> = ({
  visitors,
  signingOut,
  onClick,
  onSignOut,
}) => (
  <Table hover>
    <thead className="thead-dark">
      <tr>
        <th />
        <th>Surname</th>
        <th>First Names</th>
        <th>Company</th>
        <th>Car Registration</th>
        <th>Email</th>
        <th>Mobile</th>
        <th>Host</th>
        <th>In</th>
        <th>Out</th>
        <th />
      </tr>
    </thead>
    <tbody className="bg-light">
      {visitors.map((visitor) => (
        <ReceptionDesktopListItem
          key={visitor.id}
          visitor={visitor}
          signedOut={visitor.outAt !== null}
          isSigningOut={signingOut.indexOf(visitor.id) !== -1}
          onClick={() => onClick(visitor.id)}
          onSignOut={() => onSignOut(visitor)}
        />
      ))}
    </tbody>
  </Table>
);
